import { pipe } from 'ramda';
import React, { FC } from 'react';
import { Content } from 'stores/core';
import { PageContentWrapper, WidgetContainer } from '../common';
import { ProjectsReport, ProjectsReportRecord } from '../types';
import {
  PHasesCompleted,
  TasksCompleted,
  AverageCsat,
  useWidgetData,
} from '../widgets';
import { PhasesAndTasksViewTable } from './table';

export const PhasesAndTasksView: FC<{ projectsReport: ProjectsReport }> = ({
  projectsReport,
}) => {
  const records = pipe(
    () => projectsReport,
    Content.map((x) => x),
    Content.orElse([] as ProjectsReportRecord[]),
  )();

  const { phasesCompletedOnTime, tasksCompletedOnTime, averageProjectCsat } =
    useWidgetData(projectsReport);

  return (
    <PageContentWrapper>
      <WidgetContainer xs={24} md={12} lg={6} xl={6} xxl={4}>
        <PHasesCompleted value={phasesCompletedOnTime} />
        <TasksCompleted value={tasksCompletedOnTime} />
        <AverageCsat value={averageProjectCsat} />
      </WidgetContainer>
      <PhasesAndTasksViewTable projectsReportRecords={records} />
    </PageContentWrapper>
  );
};
